import { GenericError } from "@via/components/error.tsx";
import { ActionButton } from "@via/components/action-button/action-button.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { type JSX } from "react";
import { useNavigate } from "react-router-dom";

export default function MissingDatasetIdError(): JSX.Element {
  const navigate = useNavigate();

  const handleGoToDatasets = () => {
    navigate(ROUTES.COLLECTIONS);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="via-generic-error gap-4">
      <GenericError message="Dataset ID is required to add files. Please select a dataset first." />
      <div className="flex gap-4 justify-center">
        <ActionButton
          button="Go to datasets"
          primary={true}
          onClick={handleGoToDatasets}
        />
        <ActionButton button="Go back" primary={false} onClick={handleGoBack} />
      </div>
    </div>
  );
}
